export default __webpack_public_path__ + "baseball-pre.png";